// extracted by mini-css-extract-plugin
export default {"container":"TL-z","darkBackground":"UL-z","whiteBackground":"VL-z","headerButton":"WL-z","calloutHeading":"XL-z","calloutSubHeading":"YL-z"};